/**
 * 上传文件
 * @param payload
 */
export let upload = process.env.VUE_APP_API_BASE_URL + '/Storage/uploadFile';